<template>
<bdo  >

  <el-popover placement="top-end" width="600" trigger="click" v-if="typeof item.help =='string' && item.help.length>5">
      <div v-html="item.help"></div>
      <label slot="reference" class="el-form-item__label"  :for="item.nome" @click.ctrl="centerDialogVisible = true" >
         <i class="material-icons" style="float:right;line-height:40px;padding-left:6pxstyle;cursor: pointer;">help</i>
         <div class="domanda" v-html="item.domanda"></div>
      </label>
  </el-popover>
  <label v-else slot="reference" class="el-form-item__label " style="" :for="item.nome" @click.ctrl="centerDialogVisible = true">
     <div class="domanda" v-html="item.domanda"></div>
  </label>


   <el-dialog title="Informazioni per lo sviluppatuore" :visible.sync="centerDialogVisible" width="70%" top="5vh">

      <div class="row">
      <div class="col s3 yo-text-bold">NOME</div>
      <div class="col s9">{{item.nome}} </div>
      <div class="col s3 yo-text-bold">GRUPPO</div>
      <div class="col s9">{{item.gruppo}}</div>
      <div v-if="item.consistenza.length>8" class="col s3 yo-text-bold" >CONSISTENZA</div>
      <div v-if="item.consistenza.length>8" class="col s9">{{item.consistenza}} </div>
      <div v-if="item.note.length>8" class="col s3 yo-text-bold">NOTE</div>
      <div v-if="item.note.length>8" class="col s9">{{item.note}} </div>
      <div v-if="item.answer.length>8" class="col s3 yo-text-bold">ANSWER</div>
      <div v-if="item.answer.length>8" class="col s9">{{item.answer}} </div>
      </div>

   </el-dialog>


</bdo>
</template>

<script>
export default {
  props: {
    variabile: ''
  },
  data() {
      return {
        centerDialogVisible: false
      }
    },
  computed:{
    item:function(){
        return this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)
    }
  }
}
</script>

